export class MedicalEquipment {
    id = null;
    name = null;
    code = null;
    description = null;
    isUsing = true;
    entryDate = new Date()
    medicalEquipmentAttachFiles=[]
    
}